/* Common variables */

var typo3Path = 'typo3conf/ext/stratis_site/Resources/Public/';

var pathImg = typo3Path + "Images/",
    pathImgFancybox = typo3Path + "Images/fancybox/";
